import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreLevel1_Landscape } from "./storeLevel1_landscape";
import { StoreLevel1_Potrait } from "./storeLevel1_potrait";
import { HCOMMERCE, LANDSCAPE } from "../../../config/Constant";
import { sendAnalytics } from "../../../Redux/Actions/analyticsAction";
import { setRenderFlashMessage } from "../../../Redux/Actions/appConfigAction";

export const StoreLevel1 = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));
    
    const dispatch = useDispatch();
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    
    const [selectedStoreType, setSelectedStoreType] = useState({});

    const showMenuUnavailableToast = () => {
        dispatch(setRenderFlashMessage(true, {
            type: 'info',
            message: 'This menu is currently not available for ordering.',
        }));
    };

    const handleSelectStoreType = (category) => {
        setSelectedStoreType(category);
        if (category.id && category.isAvailable === false) {
            showMenuUnavailableToast();
        }
    };

    useEffect(()=>{
        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 1", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    if (appOrientation == LANDSCAPE) {
        return <StoreLevel1_Landscape 
            {...props} 
            showMenuUnavailableToast={showMenuUnavailableToast}
            handleSelectStoreType={handleSelectStoreType}
            selectedStoreType={selectedStoreType}
            setSelectedStoreType={setSelectedStoreType}
        />;
    } else {
        return <StoreLevel1_Potrait 
            {...props}
            showMenuUnavailableToast={showMenuUnavailableToast}
            handleSelectStoreType={handleSelectStoreType}
            selectedStoreType={selectedStoreType}
            setSelectedStoreType={setSelectedStoreType}
        />;
    }
}